import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { IImpuestoConcepto } from '../../shared/interfaces/database/liquidacion';

@Injectable({
  providedIn: 'root'
})
export class ImpuestoConceptoService {

  private readonly baseUrl = `${environment.apiUrl}/api/impuesto-concepto`;

  constructor(private http: HttpClient) { }

  getImpuestoConcepto(): Observable<IImpuestoConcepto[]> {
    return this.http.get<IImpuestoConcepto[]>(`${this.baseUrl}`);
  }

  getImpuestoConceptoForCosto(): Observable<IImpuestoConcepto[]> {
    return this.http.get<IImpuestoConcepto[]>(`${this.baseUrl}/costo`);
  }
}
